/* @flow */
import Subscriber from 'entities/Subscriber';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';

// $FlowIssue
class Subscribers extends Collection<Subscriber> {
  initialize() {
    // $FlowIssue
    this.url = '/subscribers';
    this.model = Subscriber;
  }

  // $FlowFixMe we don't support Backbone's full contract
  comparator(a: Subscriber, b: Subscriber): number {
    return a.getName().localeCompare(b.getName());
  }

  sortByFirstName() {
    return this.sortBy(subscriber => {
      return `${subscriber.getFirstName()} ${subscriber.getLastName()}`.toLowerCase();
    });
  }

  sortByLastName() {
    return this.sortBy(subscriber => {
      return `${subscriber.getLastName()}, ${subscriber.getFirstName()}`.toLowerCase();
    });
  }

  sortBySubscribedAt() {
    return this.sortBy(subscriber => {
      return -subscriber.getSubscribedAt();
    });
  }

  static export(groupIds: Backbone$Id[]) {
    return apiRequest('/subscribers/export', 'POST', {
      group_ids: groupIds,
    });
  }
}

export default Subscribers;
